// extracted by mini-css-extract-plugin
export default {"ribbon":"styles__ribbon--uphtt","icon":"styles__icon--xGw1t"};